var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegistrationForm',{on:{"submit":_vm.handleSubmit}},[_c('template',{slot:"header"},[_c('FormHeader',[_vm._v("Регистрация")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }